var map = {
	"./evaluation-result.svg": "3889",
	"./example.svg": "1699",
	"./jingtan-project-num.svg": "df4d",
	"./link.svg": "0982",
	"./list-icon.svg": "e276",
	"./logo.svg": "088a",
	"./market-dynamic.svg": "bcbf",
	"./price-info.svg": "ee6d",
	"./pur-notice.svg": "4568",
	"./pur-total-money.svg": "103a",
	"./recommend.svg": "07bc",
	"./trumpet.svg": "a622",
	"./work-dynamic.svg": "9ee1",
	"./xunjia-project-num.svg": "0d29",
	"./zhaobiao-project-num.svg": "d706"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16aa";